import { createSlice } from "@reduxjs/toolkit";
import { addCuisineAPI } from "../../api/cuisine";

const data = {
  isLoading: false,
  error: "",
  message: null,
  data: null,
}; 

const addCuisineSlice = createSlice({
  name: "addCuisine",
  initialState: data,
  reducers: {
   addCuisineSlice(state) {
      state.isLoading = true;
    },
   addCuisineSliceSuccess(state, action) {
      state.isLoading = false;
      state.data = action.payload;
    },
    addCuisineSliceFailure(state, action) {
      state.isLoading = false;
      state.data = action.payload;
    },
   addCuisineSliceReset(state) {
      state.isLoading = false;
      state.data = null;
    },
  },
});
export const addCuisineHandler = (data:any) => async (dispatch: any) => {
  try {
    dispatch(addCuisineAction.addCuisineSlice());
    const response: any = await addCuisineAPI(data);
    
    dispatch(addCuisineAction.addCuisineSliceSuccess(response));
  } catch (e: any) {
    dispatch(addCuisineAction.addCuisineSliceFailure(e?.response?.data));
  }
};
export default addCuisineSlice.reducer;
export const addCuisineAction = addCuisineSlice.actions;
